"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortBy = SortBy;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactInstantsearchHooks = require("react-instantsearch-hooks");

var _SortBy = require("../ui/SortBy");

var _excluded = ["items", "transformItems"];

function SortBy(_ref) {
  var items = _ref.items,
      transformItems = _ref.transformItems,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useSortBy = (0, _reactInstantsearchHooks.useSortBy)({
    items: items,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.sortBy'
  }),
      currentRefinement = _useSortBy.currentRefinement,
      options = _useSortBy.options,
      refine = _useSortBy.refine;

  var uiProps = {
    items: options,
    value: currentRefinement,
    onChange: refine
  };
  return /*#__PURE__*/_react.default.createElement(_SortBy.SortBy, (0, _extends2.default)({}, props, uiProps));
}